import { Chip, Grid, makeStyles, Paper, Typography } from "@material-ui/core"
import React, { useEffect } from "react"
import LoadPage from "../../components/LoadPage"
import PageCustom from "../../components/PageCustom"
import TitleElement from "../../components/TitleElement"
import PlatformRequest from "../../utils/PlatformRequest"
import ActionHasNoHasPart from "../../components/ActionHasNoHasPart";
import ChipContact from "../../components/ChipContact";
import PlacaMercosul from "../../components/PlacaMercosul"

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(3),
        textAlign: 'center'
    },
    avatarIcon: {
        backgroundColor: "gray"
    }
}))

const SearchDetailPage = (props) => {
    const classes = useStyles()
    const [load, setLoad] = React.useState(false)
    const [showContact, setShowContact] = React.useState(false)
    const [showAction, setShowAction] = React.useState(false)
    const [search, setSearch] = React.useState(
        {
            id: "",
            description: "",
            client: null,
            segmentList: [],
            nationalityList: [],
            brandCarList: [],
            carTypeList: [],
            partList: [],
            enable: false,
            partFound: false,
            status: "",
            contactSearch: {
                name: "",
                contactList: []
            },
            createdAt: ""
        }
    )

    useEffect(() => {
        loadSearch(props.match.params.id)
    }, [props.match.params.id]) // eslint-disable-line react-hooks/exhaustive-deps

    const loadSearch = (id) => {
        setLoad(true)
        PlatformRequest.getSearch(id)
            .then((response) => {
                setLoad(false)
                const { body } = response
                const { partFound, enable } = body
                setSearch(body)

                if (partFound) {
                    setShowContact(true)
                }

                if (enable && !partFound) {
                    setShowAction(true)
                }
            })
            .catch((err) => {
                // window.close()
            })
    }

    const hideAction = (hasPart) => {
        setShowAction(false)
        if (hasPart) {
            setShowContact(true)
        }
    }

    return (
        <PageCustom title="Busca">
            <LoadPage load={load} />

            {search.status === "Busca finalizada" ?
                <Grid
                    container
                    direction="row-reverse"
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    spacing={2}>
                    <Grid item>
                        <Chip
                            label={search.status}
                            color="primary"
                            variant="outlined"
                        />
                    </Grid>

                </Grid>
                : null}

            {showAction ?
                <div>
                    <Grid
                        container
                        direction="row-reverse"
                        justifyContent="flex-end"
                        alignItems="flex-end"
                        spacing={2}>
                        <Grid item>
                            <ActionHasNoHasPart
                                search={search.id}
                                callback={hideAction}
                                hasVariant="contained"
                                noHasVariant="outlined"
                                buttonNoHasPartText="Não possuo a peça"
                                buttonHasPartText="possuo a peça"
                                tooltipHas="Possuo a peça"
                                tooltipNoHas="Não possuo a peça"
                            />
                        </Grid>
                    </Grid>
                    <br />
                </div>
                :
                null
            }

            <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={2}>

                {/* Description */}
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Paper elevation={3} className={classes.paper}>
                        <Grid container direction="row" justifyContent="flex-start" spacing={4} alignItems="flex-start">
                            <Grid item zeroMinWidth>
                                <Grid container direction="column" justifyContent="flex-start" spacing={0} alignItems="flex-start">
                                    <Grid item>
                                        <Typography variant="h4" align="left">
                                            {search.description}
                                        </Typography>
                                    </Grid>
                                    <Grid item zeroMinWidth>
                                        <Typography variant="caption" align="left">
                                            Pesquisa feita em {search.createdAt}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>

                {/* Client Information */}
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Paper elevation={1} className={classes.paper}>
                        <TitleElement
                            title={<Typography variant="subtitle2">
                                Cliente
                            </Typography>}
                            element={
                                <Typography variant="h6" >
                                    {search.contactSearch.name}
                                </Typography>
                            } divider />

                        {showContact ?
                            <TitleElement
                                title={<Typography variant="subtitle2">
                                    Contato
                                </Typography>}
                                element={
                                    search.client !== null ?
                                        <ChipContact contacts={search.client.contacts} /> : <ChipContact contacts={search.contactSearch.contactList} />
                                } divider />
                            : null}
                    </Paper>
                </Grid>

                {/* Part Information */}
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <Paper elevation={1} className={classes.paper}>
                        <TitleElement
                            title={<Typography variant="subtitle2">
                                Tipo do Veículo
                            </Typography>}
                            element={
                                <Typography variant="h6" >
                                    {search.carTypeList[0]}
                                </Typography>
                            } divider />

                        <TitleElement
                            title={<Typography variant="subtitle2">
                                Marca do Veículo
                            </Typography>}
                            element={
                                <Typography variant="h6" >
                                    {search.brandCarList[0]}
                                </Typography>
                            } divider />

                        <TitleElement
                            title={<Typography variant="subtitle2">
                                Nacionalidade
                            </Typography>}
                            element={
                                search.nationalityList.map((nationality) => (
                                    <Chip variant="outlined" color="secondary" className={classes.chipElement} label={nationality} onClick={() => { }} />
                                ))
                            } divider />

                        <TitleElement
                            title={<Typography variant="subtitle2">
                                Seguimentos
                            </Typography>}
                            element={
                                search.segmentList.map((segment) => (
                                    <Chip variant="outlined" color="secondary" className={classes.chipElement} label={segment} onClick={() => { }} />
                                ))
                            } divider />

                        <TitleElement
                            divider={search.licensePlate !== undefined && search.licensePlate !== null}
                            title={<Typography variant="subtitle2">
                                Tipo de Peça
                            </Typography>}
                            element={
                                search.partList.map((part) => (
                                    <Chip variant="outlined" color="secondary" className={classes.chipElement} label={part} onClick={() => { }} />
                                ))
                            } />

                        {
                            search.licensePlate !== undefined && search.licensePlate !== null && search.licensePlate !== "" ?
                                <TitleElement
                                    title={<Typography variant="subtitle2">
                                        Placa do Veículo
                                    </Typography>}
                                    element={
                                        <div>
                                            <PlacaMercosul numeroPlaca={search.licensePlate} />
                                        </div>
                                    }
                                /> : null
                        }
                    </Paper>
                </Grid>


            </Grid>
        </PageCustom >
    )
}

export default SearchDetailPage